import { render, staticRenderFns } from "./NoVideoDialog.vue?vue&type=template&id=0ecd1bda"
import script from "./NoVideoDialog.vue?vue&type=script&lang=js"
export * from "./NoVideoDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports